export const FREETEXT_KEYS = {
    back_button: 'back_button',
    ballot_receipt_error_btn_link: 'ballot_receipt_error_btn_link',
    ballot_receipt_error_btn: 'ballot_receipt_error_btn',
    ballot_receipt_error_title: 'ballot_receipt_error_title',
    ballot_receipt_success_btn_link: 'ballot_receipt_success_btn_link',
    ballot_receipt_success_btn: 'ballot_receipt_success_btn',
    ballot_receipt_success_message: 'ballot_receipt_success_message',
    ballot_receipt_success_title: 'ballot_receipt_success_title',
    ballot_title: 'ballot_title',
    btn_close_tab: 'btn_close_tab',
    btn_see_candidates: 'btn_see_candidates',
    footer_content: 'footer_content',
    footer_copyright: 'footer_copyright',
    login_error_access_denied: 'login_error_access_denied',
    login_error_unauthorized: 'login_error_unauthorized',
    login_form_freetext: 'login_form_freetext',
    login_form_incorrect_region: 'login_form_incorrect_region',
    login_form_ingress: 'login_form_ingress',
    login_form_login_btn: 'login_form_login_btn',
    login_form_login_info: 'login_form_login_info',
    login_form_no_active_election: 'login_form_no_active_election',
    login_form_txt: 'login_form_txt',
    stand_admin_login_error: 'stand_admin_login_error',
    stand_admin_receipt_btn: 'stand_admin_receipt_btn',
    warning_already_voted: 'warning_already_voted',
};
